import cx from "classnames";

import Box from "ds/components/Box";

import styles from "./styles.module.css";

type BlueprintsTableWrapperProps = {
  children: React.ReactNode;
  hasPagination?: boolean;
};

/** Scrolling container for Table */
const TableWrapper = ({ children, hasPagination = true }: BlueprintsTableWrapperProps) => {
  return (
    <Box className={cx(styles.tableWrapper, { [styles.hasPagination]: hasPagination })}>
      {children}
    </Box>
  );
};

TableWrapper.displayName = "DS.Table.Wrapper";
export default TableWrapper;
